import { render, staticRenderFns } from "./preview-post.vue?vue&type=template&id=5ef7e324&scoped=true&"
import script from "./preview-post.vue?vue&type=script&lang=js&"
export * from "./preview-post.vue?vue&type=script&lang=js&"
import style0 from "./preview-post.vue?vue&type=style&index=0&id=5ef7e324&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef7e324",
  null
  
)

component.options.__file = "src/demo/packageEditor/preview-post.vue"
export default component.exports